<template>
   <div v-if="show" :class="{global:global}">
          <loader
            :animation-duration="2500"
            :rhombus-size="25"
            color="#f9f300"
          />
        </div>
</template>

<script>
import { LoopingRhombusesSpinner } from 'epic-spinners'
export default {
  name: 'app-loader',
  props: {
    show: {
      type: Boolean
    },
    global: {
      type: Boolean,
      default: true
    }
  },
  components: {
    loader: LoopingRhombusesSpinner
  }
}
</script>

<style scoped>
.global {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(255 255 255 / 44%);
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// loader.vue?58083229